/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { FlexContainer, Switch, Text, Spacer, theme } from "@nordcloud/gnui";
import { FilterHeader, Mode, getSelectedMode } from "~/components";
import { FiltersProp } from "~/models/estateRecordRow";
import { noop } from "~/tools";
import { useFilters } from "../hooks";
import { EstateDateRangeFilter } from "./EstateDateRangeFilter";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  isExcludeSelected?: boolean;
  onModeChage?: (mode: Mode) => void;
};

export function UnallocatedEstateFilter({
  filters,
  updateFilters,
  isExcludeSelected = false,
  onModeChage,
}: Props) {
  const {
    assignmentUpdatedFrom = "",
    assignmentUpdatedTo = "",
    unassigned = false,
  } = filters;

  const { clearUnallocatedFilters } = useFilters({ filters, updateFilters });

  useEffect(() => {
    if (!unassigned) {
      clearUnallocatedFilters();
    }
    // missing params will invoke infinite loop, thus disabling exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unassigned]);

  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChage}
      />
      <Spacer height={theme.spacing.spacing04} />
      <FlexContainer marginBottom={theme.spacing.spacing02}>
        <Switch
          checked={unassigned}
          severity="primary"
          data-testid="unallocated-switch"
          onChange={() =>
            updateFilters({
              unassigned: !unassigned,
            })
          }
        />
        <Text marginLeft={theme.spacing.spacing02} marginBottom={0}>
          Show Unallocated Estate Records
        </Text>
      </FlexContainer>
      <EstateDateRangeFilter
        description="Define the dates of estate records` environment change from allocated to unallocated."
        dateFrom={assignmentUpdatedFrom}
        dateTo={assignmentUpdatedTo}
        disabled={!unassigned}
        onDateFromChange={(value) =>
          updateFilters({
            assignmentUpdatedFrom: value,
          })
        }
        onDateToChange={(value) =>
          updateFilters({
            assignmentUpdatedTo: value,
          })
        }
      />
    </>
  );
}
